// https://confluence.my.games/display/MGPLATFORM/Installing+1link+on+landings+to+count+CR+to+actions+inside+MY.GAMES+Launcher
//

export default {
  data() {
    return {
      pID: 104482,
    };
  },
  methods: {
    async sendImpression() {
      const url = window.location.hostname + window.location.pathname;
      const sanitizedUrl = url.replace(/[^0-9a-zA-Z.]/g, ".");
      const sanitizedUrl32 = sanitizedUrl.substring(sanitizedUrl.length - 32);
      const viewUrl = `https://1l-s2s.my.games/v/adid/3766647_1/pid/129519/f/3/?_1larg_sub=${sanitizedUrl32}&_1larg_sub3=${this.pID}&_1larg_responseType=1`;

      try {
        await new Promise((resolve) => setTimeout(resolve, 700));
        await fetch(viewUrl, { credentials: "include" });
      } catch (error) {
        console.error(`Impression fire error: ${error.message}`);
      }
    },
    async sendClick(buttonName = "play") {
      const url = window.location.hostname + window.location.pathname;
      const sanitizedUrl = url.replace(/[^0-9a-zA-Z.]/g, ".");
      const sanitizedUrl32 = sanitizedUrl.substring(sanitizedUrl.length - 32);
      const clickUrl = `https://1l-s2s.my.games/s2s/adid/3766647_1/pid/129519/f/1/?_1larg_sub=${sanitizedUrl32}&_1larg_sub2=${buttonName}&_1larg_sub3=${this.pID}&_1larg_responseType=1`;

      try {
        await fetch(clickUrl, { credentials: "include" });
      } catch (e) {
        console.error(`Click fire error: ${e.message}`);
      }
    },
  },
};
